import Box from '@mui/material/Box';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import TimerRoundedIcon from '@mui/icons-material/TimerRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

export const MENU_ICON_OPTIONS = [
  { value: 'folder', label: 'Dossier' },
  { value: 'assignment', label: 'Commande' },
  { value: 'inventory', label: 'Stock' },
  { value: 'store', label: 'Magasin' },
  { value: 'people', label: 'Clients' },
  { value: 'badge', label: 'Utilisateur' },
  { value: 'admin', label: 'Administration' },
  { value: 'settings', label: 'Paramètres' },
  { value: 'stats', label: 'Statistiques' },
  { value: 'chart', label: 'Graphique' },
  { value: 'build', label: 'Atelier' },
  { value: 'support', label: 'Logistique' },
  { value: 'dashboard', label: 'Dashboard' },
  { value: 'pilotage', label: 'Pilotage' },
  { value: 'stats-mounting', label: 'Stats montage' },
  { value: 'stats-delay', label: 'Stats délais' },
  { value: 'stats-stock', label: 'Stats stock' },
  { value: 'stats-logistics', label: 'Stats Logistique' },
  { value: 'supplier-accounts', label: 'Comptes fournisseurs' },
];

function createStatsIcon(MainIcon) {
  return function StatsIcon({ sx, ...props }) {
    return (
      <Box
        component="span"
        sx={{
          position: 'relative',
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'inherit',
          ...sx,
        }}
        {...props}
      >
        <MainIcon sx={{ fontSize: 21 }} />
        <QueryStatsRoundedIcon
          sx={{
            position: 'absolute',
            right: -4,
            bottom: -4,
            fontSize: 14,
            p: '1px',
            borderRadius: '50%',
            bgcolor: 'background.paper',
            color: 'primary.main',
          }}
        />
      </Box>
    );
  };
}

const iconMap = {
  folder: FolderRoundedIcon,
  assignment: AssignmentRoundedIcon,
  inventory: Inventory2RoundedIcon,
  store: StoreRoundedIcon,
  people: PeopleRoundedIcon,
  badge: BadgeRoundedIcon,
  admin: AdminPanelSettingsRoundedIcon,
  settings: SettingsRoundedIcon,
  stats: QueryStatsRoundedIcon,
  chart: BarChartRoundedIcon,
  build: BuildRoundedIcon,
  support: LocalShippingRoundedIcon,
  dashboard: DashboardRoundedIcon,
  pilotage: SpeedRoundedIcon,
  'stats-mounting': createStatsIcon(BuildRoundedIcon),
  'stats-delay': createStatsIcon(TimerRoundedIcon),
  'stats-stock': createStatsIcon(Inventory2RoundedIcon),
  'stats-logistics': createStatsIcon(LocalShippingRoundedIcon),
  'supplier-accounts': AccountBalanceWalletRoundedIcon,
  history: HistoryRoundedIcon,
};

const LEGACY_MENU_LABELS = {
  'logistique-commandes': 'Commandes Logistique',
  'logistique-documents': 'Documents Logistique',
  'stock-commandes': 'Commandes - Verre de stock',
  'stock-reservations': 'Réservations - Verre de stock',
  'suivi-atelier-bl': 'Bons de livraison - Suivi atelier',
  'supplier-accounts': 'Comptes fournisseurs',
};

export const DEFAULT_MENU_CONFIG = {
  groups: [
    { id: 'pilotage', label: 'Pilotage', icon: 'pilotage', order: 0.5 },
    { id: 'production', label: 'Production', icon: 'folder', order: 1 },
    { id: 'administration', label: 'Administration', icon: 'folder', order: 2 },
  ],
  items: [
    { id: 'suivi-atelier', label: 'Suivi atelier', icon: 'assignment', path: '/suivi-atelier', groupId: 'production', order: 1, enabled: true },
    { id: 'suivi-atelier-bl', label: 'Bons de livraison', icon: 'support', path: '/suivi-atelier/bl', groupId: 'production', parentId: 'suivi-atelier', order: 1.25, enabled: true },
    { id: 'sav', label: 'Logistique', icon: 'support', path: '/sav', groupId: 'production', order: 2, enabled: true },
    { id: 'logistique-commandes', label: 'Commandes', icon: 'support', path: '/sav-commandes', groupId: 'production', parentId: 'sav', order: 3, enabled: true },
    { id: 'logistique-documents', label: 'Documents', icon: 'assignment', path: '/sav/documents', groupId: 'production', parentId: 'sav', order: 3.25, enabled: true },
    { id: 'stock-verres', label: 'Verres de stock', icon: 'inventory', path: '/stock/verres', groupId: 'production', order: 4, enabled: true },
    { id: 'stock-reservations', label: 'Réservations', icon: 'inventory', path: '/stock/reservations', groupId: 'production', parentId: 'stock-verres', order: 4.25, enabled: true },
    { id: 'stock-commandes', label: 'Commandes', icon: 'inventory', path: '/stock/commandes', groupId: 'production', parentId: 'stock-verres', order: 4.5, enabled: true },
    { id: 'stock-reassort', label: 'Réassort', icon: 'inventory', path: '/stock/reassort', groupId: 'production', parentId: 'stock-verres', order: 4.6, enabled: true },
    { id: 'commandes', label: 'Commandes stock', icon: 'assignment', path: '/commandes', groupId: 'production', order: 99, enabled: false },
    { id: 'stats-montage', label: 'Stats montage', icon: 'stats-mounting', path: '/statistiques', groupId: 'production', order: 5, enabled: true, permission: 'VIEW_STATISTICS' },
    { id: 'stats-delais', label: 'Stats délais', icon: 'stats-delay', path: '/statistiques/delais', groupId: 'production', order: 6, enabled: true, permission: 'VIEW_STATISTICS' },
    { id: 'stats-delais-v2', label: 'Stats délai V2', icon: 'stats-delay', path: '/statistiques/delais-v2', groupId: 'pilotage', order: 6.1, enabled: true, adminOnly: true },
    { id: 'stats-stock', label: 'Stats stock', icon: 'stats-stock', path: '/statistiques/stock', groupId: 'production', order: 7, enabled: true, permission: 'VIEW_STATISTICS' },
    { id: 'stats-logistique', label: 'Stats Logistique', icon: 'stats-logistics', path: '/statistiques/logistique', groupId: 'production', order: 8, enabled: true },
    { id: 'clients', label: 'Clients', icon: 'people', path: '/clients', groupId: 'administration', order: 1, enabled: true },
    { id: 'sites', label: 'Sites', icon: 'store', path: '/sites', groupId: 'administration', order: 2, enabled: true },
    { id: 'suppliers', label: 'Fournisseurs', icon: 'supplier-accounts', path: '/fournisseurs', groupId: 'administration', order: 3, enabled: true, permission: 'MANAGE_LOGISTICS_SUPPLIERS' },
    { id: 'supplier-accounts', label: 'Comptes fournisseurs', icon: 'supplier-accounts', path: '/comptes-fournisseurs', groupId: 'administration', parentId: 'suppliers', order: 3.1, enabled: true, permission: 'MANAGE_LOGISTICS_SUPPLIERS' },
    { id: 'utilisateurs', label: 'Utilisateurs', icon: 'badge', path: '/utilisateurs', groupId: 'administration', order: 5, enabled: true },
    { id: 'roles', label: 'Rôles', icon: 'admin', path: '/roles', groupId: 'administration', order: 6, enabled: true },
    { id: 'settings', label: 'Paramètres', icon: 'settings', path: '/settings', groupId: 'administration', order: 7, enabled: true, permission: 'MANAGE_LOGISTICS_SUPPLIERS' },
    { id: 'supplier-brand-rules', label: 'Logistique', icon: 'settings', path: '/settings/logistique/marques', groupId: 'administration', parentId: 'settings', order: 7.1, enabled: true, permission: 'MANAGE_LOGISTICS_SUPPLIERS' },
    { id: 'journal', label: 'Journal', icon: 'history', path: '/journal', groupId: 'administration', order: 8, enabled: true, permission: 'VIEW_ACTIVITY_LOG' },
  ],
};

export function getMenuIcon(iconName, props = {}) {
  const Icon = iconMap[iconName] || FolderRoundedIcon;
  return <Icon {...props} />;
}

export function normalizeMenuConfig(value) {
  const source = value && typeof value === 'object' ? value : {};
  const defaultGroupsById = new Map(DEFAULT_MENU_CONFIG.groups.map((group) => [group.id, group]));
  const customGroups = Array.isArray(source.groups) ? source.groups : [];
  const groupsById = new Map(DEFAULT_MENU_CONFIG.groups.map((group) => [group.id, { ...group }]));

  customGroups.forEach((group) => {
    if (!group?.id) return;
    groupsById.set(group.id, {
      ...(defaultGroupsById.get(group.id) || {}),
      ...group,
      label: group.label || defaultGroupsById.get(group.id)?.label || group.id,
      icon: group.icon || defaultGroupsById.get(group.id)?.icon || 'folder',
      order: Number(group.order || defaultGroupsById.get(group.id)?.order || 999),
    });
  });

  const customItemsById = new Map((Array.isArray(source.items) ? source.items : []).map((item) => [item.id, item]));
  // These entries have a deliberate hierarchy. Existing stored preferences must
  // not restore their former locations after this reorganisation.
  const forcedParents = {
    suppliers: undefined,
    'supplier-accounts': 'suppliers',
    'supplier-brand-rules': 'settings',
  };
  // Stats délai V2 is an administration-only pilotage view. Keep this
  // placement when normalizing menus saved before the Pilotage section existed.
  const forcedGroups = {
    'stats-delais-v2': 'pilotage',
  };
  const items = DEFAULT_MENU_CONFIG.items.map((defaultItem) => {
    const customItem = customItemsById.get(defaultItem.id) || {};
    const customLabel = customItem.label && customItem.label !== LEGACY_MENU_LABELS[defaultItem.id]
      ? customItem.label
      : '';
    return {
      ...defaultItem,
      ...customItem,
      id: defaultItem.id,
      path: defaultItem.path,
      permission: defaultItem.permission,
      parentId: Object.prototype.hasOwnProperty.call(forcedParents, defaultItem.id)
        ? forcedParents[defaultItem.id]
        : (customItem.parentId || defaultItem.parentId),
      label: customLabel || defaultItem.label,
      icon: customItem.icon || defaultItem.icon,
      groupId: Object.prototype.hasOwnProperty.call(forcedGroups, defaultItem.id)
        ? forcedGroups[defaultItem.id]
        : (customItem.groupId || defaultItem.groupId),
      order: Number(customItem.order || defaultItem.order || 999),
      enabled: defaultItem.enabled === false ? false : customItem.enabled !== false,
    };
  });

  return {
    groups: [...groupsById.values()].sort((a, b) => a.order - b.order || a.label.localeCompare(b.label)),
    items,
  };
}
